import moment from 'moment/moment';

import { IMAGE_RATIO_LIST } from '../constants/arrayListConst';
import { DATE_FORMAT_DD_MM_YYYY } from '../constants/dateFormatsConst';

export const convert24HourTo12Hour = time24 => {
  if (time24) {
    const [hours, minutes] = time24.split(':');
    let hour = parseInt(hours);
    const period = hour >= 12 ? 'pm' : 'am';
    if (hour > 12) {
      hour -= 12;
    } else if (hour === 0) {
      hour = 12;
    }
    const time12 = `${hour}:${minutes} ${period}`;
    return time12;
  }
  return '';
};

export function flattenObject(obj, parentKey = '') {
  const result = {};
  for (const key in obj) {
    if (Object.hasOwnProperty.call(obj, key)) {
      const newKey = parentKey ? `${parentKey}_${key}` : key;

      if (typeof obj[key] === 'object' && obj[key] !== null) {
        Object.assign(result, flattenObject(obj[key], newKey));
      } else {
        result[newKey] = obj[key];
      }
    }
  }
  return result;
}

export function convertArrayIntoSingleObject(arrayOfObjects = []) {
  const mergedObject = arrayOfObjects?.reduce((result, obj) => {
    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        result[key] = obj[key];
      }
    }
    return result;
  }, {});
  return mergedObject;
}

export const customArrayMove = (array, fromIndex, toIndex) => {
  const newArray = [...array]; // Create a shallow copy of the original array
  const [movedItem] = newArray.splice(fromIndex, 1); // Remove the item from the original position
  newArray.splice(toIndex, 0, movedItem); // Insert the item at the new position
  return newArray;
};

export const toCamelCase = str => {
  return str
    ? str
        .toString()
        .trim()
        .replace(/[-_](.)/g, (_, char) => char.toUpperCase())
    : '';
};

export const toTitleCase = str => {
  return str
    ? str
        .toString()
        .trim()
        .replace(/[-_](.)/g, (_, char) => ` ${char.toUpperCase()}`)
        .replace(/^./, char => char.toUpperCase())
    : '';
};

export const isVideoExtension = pathUrl => {
  return /\.mp4\b/i.test(pathUrl);
};

export const isValidHostname = hostname => {
  if (hostname && hostname.length > 128) {
    return false;
  }
  if (/^(https?:\/\/|www\.)/.test(hostname)) {
    return false;
  }
  hostname = hostname?.trim();
  if (hostname?.endsWith('.')) {
    hostname = hostname?.slice(0, -1);
  }
  const allowedPattern = /^(?!-)[A-Za-z0-9-]{1,63}(?<!-)$/;
  return hostname?.split('.').every(segment => allowedPattern.test(segment));
};

export const arraysAreEqual = (arr1, arr2) => {
  if (arr1 === null) {
    return true;
  } else if (arr2 === null) {
    return true;
  } else if (!arr1 || !arr2) {
    return false;
  } else if (arr1?.length !== arr2?.length) {
    return false;
  }
  return arr1?.every((value, index) => value === arr2[index]);
};

export const objectsAreEqual = (obj1, obj2) => {
  if (obj1 === obj2) {
    return true;
  }
  if (!obj1 || !obj2) {
    return false;
  }
  const normalize = obj => JSON.stringify(obj);
  return normalize(obj1) === normalize(obj2);
};

export const getRatioLabel = currentRatio => {
  return IMAGE_RATIO_LIST.find(f => f.value === currentRatio).label;
};

export const getAspectRatioCss = currentRatio => {
  return IMAGE_RATIO_LIST.find(f => f.value === currentRatio).css;
};

export const formatDate = (date, format = DATE_FORMAT_DD_MM_YYYY) => {
  // date can be a Date object, ISO string, or timestamp
  if (!date) {
    return null; // Handle empty input safely
  }
  return moment(date).format(format);
};

export const mapEnumToArray = enumObj => {
  if (!enumObj) {
    return [];
  }
  return Object.entries(enumObj).map(([key, value]) => ({
    value,
    label: key
      .toLowerCase()
      .replace(/_/g, ' ')
      .replace(/\b\w/g, c => c.toUpperCase())
  }));
};

export const getKeyByValue = (object, value) => {
  return Object.keys(object).find(key => object[key] === value);
};
